import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, FormGroup, FormBuilder } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-helptext',
  templateUrl: './helptext.page.html',
  styleUrls: ['./helptext.page.scss'],
})
export class HelptextPage implements OnInit {

  @ViewChild('f', { read: NgForm }) form: any;
  
  faqForm: FormGroup;
  submitted = false;
  helpTextId: string = ''
  helptexts: any = {};
  tempHelpTexts: any = {}
  showPage: boolean = false
  locale: any = ''
  moduleList: any = []
  tempLocale: any = ''

  constructor(private formBuilder: FormBuilder, private location: Location, private _apiService: ApiService, public _commonService: CommonService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
  }

  async ionViewDidEnter(){
   
    this.submitted = false;
    this.locale = Number((localStorage.locale && localStorage.locale != '') ? localStorage.locale : 1043);
    this.tempLocale = this.locale;
    this.helpTextId = this.route.snapshot.paramMap.get('id');
    if (this.helpTextId == '0') {
      this.helpTextId = null;
    }
    if (this.helpTextId) {
      this.getHelpTextDetail();
    }else{
      await this.getModuleList()
      this.showPage = true;
      this.helptexts = {
        HelpTextDescription: ''
      }
    }
   
  }

  async getHelpTextDetail(){
    this._commonService.presentLoading();
    try {
      let res = await this._apiService.getHelpTextDetails(this.helpTextId);
      this.helptexts = res.body;
      this.tempHelpTexts = res.body;
      await this.getModuleList()
     this._commonService.log(this.helptexts, this._commonService.LOG);
     this._commonService.dismiss();
      this.showPage = true
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR)
    }
  }


  async getModuleList() {
    try {
      let res = await this._apiService.getModules('','','',1,0)
      res.body.forEach(element => {
        if(element.name_systemtranslationcode == 'Module_DocumentGenerator' || element.name_systemtranslationcode == 'Module_Quickscan'){
          this.moduleList.push(element)
        }
      });
    } catch (error) {
      this._commonService.dismiss()
      this._commonService.log(error, this._commonService.ERROR);
    }
  }


 async onSubmit(f){
    this.submitted = true
    if(f.form.invalid){
      return
    }
    this._commonService.presentLoading()
    try {
      let data = {
        Name: this.helptexts.Name || null,
        HelpTextDescription: this.helptexts.HelpTextDescription || null,
        ModuleId: this.helptexts.ModuleId || null,
      }
      if(!this.helpTextId){
        let res = await  this._apiService.postHelpText(data)
        if(res){
          this.helpTextId = res.id;
          this.location.replaceState('maintenance/helptexts/' + this.helpTextId);
        }
      }else{
        let res = await  this._apiService.putHelpText(data, this.helpTextId)
        if(res){
          this.helpTextId = res.id;
          this.location.replaceState('maintenance/helptexts/' + this.helpTextId);
        }
      }
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
      this._commonService.log(data, this._commonService.LOG);
      this.submitted = false;
     this._commonService.dismiss()
    } catch (error) {
      if(error.status >= 500 && error.status < 600){
          this.helptexts = this.tempHelpTexts
      }
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR)
    }
 
   
  }

  delete() {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          await this._apiService.deleteHelpTexts(this.helpTextId);
          this._commonService.dismiss();
          this._commonService.log(res, this._commonService.LOG);
          this.goBack();
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }

  goBack(){
  
    this.router.navigate(['maintenance/helptexts'])
  }

  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
          this.onSubmit(this.form);
          break;
      case "delete":
          this.delete();
          break;
      case "backToList":
          this.goBack();
          break;
      case "backToMain":
          this.router.navigate(['maintenance'], { replaceUrl: true })
          break;
      case "back":
          this.goBack();
          break;
      }
      
  }

  onChangeModule(event){}


}
